import { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Routes } from './routes';
import ScrollToTop from './components/ScrollToTop';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import { fetchSalonByDomain } from './redux/slices/salonSlice';
import './index.css';

/**
 * AppContent Component
 * Handles franchise selection logic
 */
function AppContent() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  
  const { franchises, selectedFranchise, loading } = useAppSelector(
    (state) => state.salon
  );

  // Initialize app - ALWAYS fetch salon by domain (localStorage used only for auto-selection)
  useEffect(() => {
    console.log('🚀 App initialized - Fetching salon by domain...');
    // ALWAYS fetch salon by domain to get fresh franchise list
    // localStorage will be used inside salonSaga for auto-selection
    dispatch(fetchSalonByDomain());
  }, [dispatch]);

  // Handle franchise selection navigation
  useEffect(() => {
    // Only navigate if we have franchises and no selected franchise
    if (!loading && franchises.length > 1 && !selectedFranchise) {
      navigate('/franchise-selection');
    }
  }, [franchises, selectedFranchise, loading, navigate]);

  return <Routes />;
}

/**
 * Main App Component
 */
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
